import { takeEvery } from 'redux-saga/effects'

const takes = (duck) => ([
    takeEvery(duck.types.GET_METRICS, duck.sagas.getMetrics),
    takeEvery(duck.types.GET_RECURRING_PAYMENTS, duck.sagas.getRecurringPayments),
    takeEvery(duck.types.SET_TIME_DIMENSION, duck.sagas.setTimeDimension),
])

export default takes
